import ConfirmationDialog from 'components/ReusableComponents/ConfirmationDialog'
import TextInput from 'components/ReusableComponents/ManageHotel/TextInput'
import usePlausible from 'hooks/usePlausible'
import { useState } from 'react'
import { Redirect, useHistory } from 'react-router'
import { useToasts } from 'react-toast-notifications'
import audienceApi from 'services/api/audience'

import styles from './NewAudience.module.scss'

const NewAudience = () => {
  const [isSubmitting, setIsSubmitting] = useState()
  const [newAudienceId, setNewAudienceId] = useState()

  const history = useHistory()

  const [name, setName] = useState()

  const { addToast } = useToasts()

  const { postEvent, plausibleEvents } = usePlausible()

  function saveAudience(name) {
    postEvent(plausibleEvents.CreateNewAudience, {
      name
    })

    setIsSubmitting(true)

    audienceApi
      .save(name)
      .then(res => {
        setNewAudienceId(res.id)
      })
      .catch(err => {
        addToast(`${err}`, {
          appearance: 'error'
        })
      })
      .finally(() => {
        setIsSubmitting(false)
      })
  }

  if (newAudienceId) {
    return <Redirect to={`/custom-audience/${newAudienceId}`} />
  }

  return (
    <ConfirmationDialog
      title="Create new audience"
      onConfirm={() => saveAudience(name)}
      isButtonDisabled={isSubmitting}
      positiveMessage="Save"
      closeLink="/custom-campaigns"
      onClose={() => history.push('/custom-campaigns')}
    >
      <TextInput
        label="Audience name"
        autoFocus
        width="100%"
        className={styles.inputHolder}
        value={name}
        onChange={e => setName(e.target.value)}
      />
    </ConfirmationDialog>
  )
}

export default NewAudience
